module.exports = __webpack_public_path__ + "static/media/DSC_0435.4b66b742.JPG";